import WelcomeView from '@/views/site/welcome'
import EditorView from '@/views/site/editor/EditorView.vue'
import ManageFaviconView from '@/views/site/favicon/ManageFaviconView.vue'
import DomainRouter from './domains'

export default [
  {
    name: 'siteWelcome',
    path: '/:siteId',
    component: WelcomeView
  },
  {
    name: 'editorView',
    path: '/:siteId/editor',
    component: EditorView,
    title: 'sidebarMenu.site.editSite'
  },
  {
    name: 'manageFavicon',
    path: '/:siteId/favicon',
    component: ManageFaviconView,
    title: 'sidebarMenu.site.manageFavicon'
  },
  ...DomainRouter
]
